import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import jwtDecode from 'jwt-decode';
import getReadableTime from '../../functions/hreadableDate';
import readablePhone from '../../functions/readablePhone';

const Receipt = (props) => {
    const [userName, setUserName] = useState('');

    useEffect(() => {
        const authToken = sessionStorage.getItem('auth-token');
        const user = jwtDecode(authToken);
        setUserName(`${user.name} ${user.lastname}`);
    }, [props])

    return (
        <div className={styles.Receipt}>
            <h5 className={styles.StoreTitle}>Servicell Wireless Repair Center</h5>
            <p className={styles.StoreInfo}>3521 NW 17th Ave Miami FL, 33142</p>
            <p className={styles.StoreInfo}>www.servicellwireless.net</p>
            <p className={styles.StoreInfo}>(305)635-9694</p>
            <h5 className={styles.OrderNumber}>Order #{props.order && props.order._workId}</h5>
            <hr />
            <p className={styles.ServiceText}>{props.order && props.order.service}</p>
            <hr />
            <table className={styles.OrderInfo}>
                <tr>
                    <td>Cashier:</td>
                    <td>{userName}</td>
                </tr>
                <tr>
                    <td>Time:</td>
                    <td>{getReadableTime(props.order && props.order.timestamp, true, true)}</td>
                </tr>
                <tr>
                    <td>Device:</td>
                    <td>{props.order && props.order.device.name}</td>
                </tr>
                <tr>
                    <td>Client:</td>
                    <td>{props.order && props.order.client.name}</td>
                </tr>
                {props.order && props.order.client.phone && <tr>
                    <td>Phone:</td>
                    <td>{props.order && readablePhone(props.order.client.phone)}</td>
                </tr>}
                {props.order && (props.order.device.password.length > 0) && <tr>
                    <td>Password:</td>
                    <td>{props.order.device.password}</td>
                </tr>}
            </table>
            <hr />
            {props.order && props.order.notes && <div className={styles.Notes}>
                <h5 className={styles.TitleObservation}>Cashier Observations</h5>
                <p className={styles.NotesObservation}>{props.order.notes}</p>
            </div>}
            <hr />
            <table className={styles.PaymentBlock}>
                <tr>
                    <td>Total:</td>
                    <td>${props.order && props.order.total.toFixed(2)}</td>
                </tr>
                <tr>
                    <td>Paid:</td>
                    <td>${props.order && props.order.paid.toFixed(2)}</td>
                </tr>
                <tr>
                    <td>{props.order && (props.order.total - props.order.paid) >= 0 ?  "Due:" : "Change:"}</td>
                    <td>${props.order && (props.order.total - props.order.paid) >= 0 ? (props.order.total - props.order.paid).toFixed(2) : Math.abs(props.order.total - props.order.paid).toFixed(2)}</td>
                </tr>
            </table>
            <div class={styles.StoreTerms}>
                <h5>Store Terms</h5>
                <p><b>1.</b> There is no refund on repairs that the customer agreed on.</p>
                <p><b>2.</b> The device will not be released without the corresponding Work Order Receipt, in case that the customer has lost the Work Order Receipt the customer will be required proof of ID and signature.</p>
                <p><b>3.</b> In case that the customer does not wish to repair the device he/she will have to pay <b>$10.00</b> fee for the diagnosis of a mobile phone or <b>$15.00</b> fee for PC, Laptop or Tablet.</p>
                <p><b>4.</b> The customer must provide a valid phone number and must report any changes in contact number to be able to call him/her to report the status of the device. We will contact the customer 30 days after the repair date to advice that he/she must pay the remaining balance and to please pick up the  device. If the device is not picked up within a 90 day period we will charge a $30.00 fee for storage and care of the device. If the device has not been picked up after 180 days (6 Month) we will consider the equipment abandoned and its property will be transferred to Servicell Wireless Repair Center Corp.</p>
                <p><b>5.</b> To unlock a phone the customer must know if there is an outstanding balance with the device with the carrier. Failing to know this information the store is not liable when the carrier decides to blacklist the device and locking the phone once again, there will be no refund because the device is supposed to be paid and out of contract.</p>
            </div>
            {props.signature && <div className={styles.Signature}>
                <p class={styles.ClientSignature}>Client Signature Below</p>
                <hr />
            </div>}
            <div class={styles.ReceiptFooter}>Thank for trusting in us!</div>
        </div>
    )
};

export default Receipt;